var mixins = {
  props: {
    bindedAttr: {
      type: String,
      default: 'id',
    },
    failed: {
      type: Boolean,
      default: false,
    },
    passed: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    storeName() {
      return this.$options.name
    },
    types() {
      return this.$store.getters.get(this.storeName)
    },
    selectedValues: {
      set(values) {
        this.$emit('input', values)
      },
      get() {
        return this.value
      },
    },
  },
  methods: {
    getTypes() {
      return this.types
    },
    toggleAll() {
      if (this.selectedValues.length == this.types.length) this.selectedValues = []
      else this.selectedValues = this.types.map((i) => i[this.bindedAttr])
    },
  },
}

export default mixins
